import React from 'react';
import { motion } from 'framer-motion';
import { Headphones, Radio, Lightbulb, Megaphone, Music, BookOpen, Trophy } from 'lucide-react';

const categoryInfo = {
  latest: { name: 'Últimos Episódios', icon: Radio },
  projects: { name: 'Projetos Escolares', icon: Lightbulb },
  news: { name: 'Notícias e Atualidades', icon: Megaphone },
  culture: { name: 'Arte e Cultura', icon: Music },
  education: { name: 'Educação', icon: BookOpen },
  sports: { name: 'Desporto Escolar', icon: Trophy }
};

interface PodcastHeroProps {
  category?: string;
}

export const PodcastHero: React.FC<PodcastHeroProps> = ({ category }) => {
  const CategoryIcon = category ? categoryInfo[category as keyof typeof categoryInfo]?.icon : Headphones;
  const categoryName = category ? categoryInfo[category as keyof typeof categoryInfo]?.name : 'Todos os Podcasts';

  return (
    <div className="relative h-[60vh] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.6)), url("https://images.unsplash.com/photo-1478737270239-2f02b77fc618?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80")',
          backgroundPosition: 'center',
          backgroundSize: 'cover'
        }}
      />
      <div className="relative h-full flex items-center justify-center text-center px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl"
        >
          <div className="flex items-center justify-center gap-4 mb-6">
            <CategoryIcon className="w-12 h-12 text-primary" />
            <h1 className="text-4xl md:text-6xl font-bold">{categoryName}</h1>
          </div>
          <p className="text-xl md:text-2xl text-gray-300">
            {category
              ? `Explore nossa coleção de podcasts sobre ${categoryName.toLowerCase()}`
              : 'Explore nossa coleção de podcasts escolares, com entrevistas, projetos e notícias do AEAAV.'}
          </p>
        </motion.div>
      </div>
    </div>
  );
};